import React from 'react';

import { formatPercentageNumber } from '~/widgets/earnings/utils/utils';
import * as S from '~/widgets/earnings-insight-drawer/earnings-insight-widget/earnings-preview/EarningsPreview.styles';

import { formatDateToET } from '../../earnings-preview/components/impacted-companies/company-card/utils';

export interface EarningsDateLabelProps {
  date?: string;
  label: string;
  oneDayReaction?: string;
  price?: number;
}

export const EarningsDateLabel = ({
  date,
  label,
  oneDayReaction,
  price,
}: EarningsDateLabelProps) => {
  return (
    <S.EarningsReleaseDate>
      <S.DateWrapper>
        <S.Date>{label} </S.Date>
        {date && <S.Span>{formatDateToET(new Date(date))}</S.Span>}
      </S.DateWrapper>
      {!!oneDayReaction && !!price && (
        <S.DateWrapper>
          <S.Date>{oneDayReaction} </S.Date>
          <S.Span>
            {price &&
              formatPercentageNumber({
                value: price,
                includePercentSign: true,
                addPlus: true,
              })}
          </S.Span>
        </S.DateWrapper>
      )}
    </S.EarningsReleaseDate>
  );
};
